import { message } from 'antd';
import { all, takeLatest } from 'redux-saga/effects';
import { SERVICE_ERROR_NOTIFICATION, SERVICE_SUCCESS_NOTIFICATION } from './notificationsActions';

export function successMessage(action) {
  message.success(action.payload.message);
}

export function errorMessage(action) {
  message.error(action.payload.message, 4);
}

export default function* notificationsSaga() {
  yield all([
    takeLatest(SERVICE_SUCCESS_NOTIFICATION, successMessage),
    takeLatest(SERVICE_ERROR_NOTIFICATION, errorMessage),
  ]);
}
